import { render } from "./ico-bigeye.vue?vue&type=template&id=6bb7387d&ts=true"
import script from "./ico-bigeye.vue?vue&type=script&lang=ts"
export * from "./ico-bigeye.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__